export const SIGN_IN = 'SIGN_IN'
export const SIGN_OUT = 'SIGN_OUT'
export const LOGGED_IN = 'LOGGED_IN'
export const LOGGED_OUT = 'LOGGED_OUT'
export const SET_ADMIN = 'SET_ADMIN'
export const SET_MEMBER = 'SET_MEMBER'
export const SET_ADMINS = 'SET_ADMINS'